import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/uns/data-explorer/")({
  staticData: {
    title: "common.dataExplorer",
  },
});
